<style scoped="scoped" lang="scss">
.inputClass /deep/ .el-input__inner {
  height: 28px !important;
}

.inputClass /deep/ .el-input__icon {
  //width: 25px !important;;
  line-height: 20px !important;
}
</style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/warehouse/purchase/page" getKey="rows" @afterGet="afterGet" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('caigoudingdanhao')">
            <el-input v-model="yt.conditions.no"></el-input>
          </el-form-item>
          <el-form-item :label="$t('gongyingshangmingcheng')">
            <yi_data_select multiple type="supplier" :ids.sync="yt.conditions.supplierIds"></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('shenhezhuangtai')">
            <el-select v-model="yt.conditions.status">
              <el-option :label="$t('daishenhe')" :value="0"></el-option>
              <el-option :label="$t('yishenhe')" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1, null, afterReq)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear(null, null, afterReq)">{{ $t('chongzhi') }}</el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button
          size="mini"
          v-if="utils.checkPower('web_purchasing_management_purchase_order_create')"
          @click="
            yt.showEditDialog('xinzeng', null, '80%', beforeShowEditDialog);
            getSupplierList();
            getCustomer();
            setDefaultValue();
          "
          type="primary"
        >
          {{ $t('xinzeng') }}
        </el-button>
        <el-button size="mini" @click="importShow = !importShow" plain v-if="utils.checkPower('web_purchasing_management_purchase_order_batchImport')">
          {{ $t('daoru') }}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"> </el-button>
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button
              v-if="utils.checkPower('web_purchasing_management_purchase_order_updateWithDetail') && scope.row.status === '0'"
              type="text"
              @click="
                yt.showEditDialog('bianji', scope.row, '80%', beforeEdit);
                getCustomer();
              "
            >
              {{ $t('bianji') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-popconfirm :title="$t('quedingshenheshuju')" :confirm-button-text="$t('queding')" @confirm="process(scope.row)">
              <el-button type="text" slot="reference" :loading="scope.row.processLoading" v-if="utils.checkPower('web_purchasing_management_purchase_order_review') && scope.row.status === '0'">{{ $t('shenhe') }} </el-button>
            </el-popconfirm>
          </el-col>
          <el-col :span="0.1">
            <el-button
              type="text"
              @click="
                yt.showEditDialog('chakan', scope.row, '80%', beforeEdit);
                getCustomer();
              "
              v-if="utils.checkPower('web_purchasing_management_purchase_order_get') && scope.row.status === '1'"
            >
              {{ $t('chakan') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" @click="reject(scope.row)" class="font-color-danger" v-if="utils.checkPower('web_purchasing_management_purchase_order_review_reject') && scope.row.rejectStatus === 0">
              {{ $t('shenhebohui') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button v-if="utils.checkPower('web_purchasing_management_purchase_order_delete') && scope.row.status === '0'" type="text" class="font-color-danger" @click="removeRecord(scope.row)">
              {{ $t('shanchu') }}
            </el-button>
            <!--            <el-button type="text" :loading="yt.editObj.loading"  class="font-color-danger"-->
            <!--                       @click="yt.remove(scope.row,'/web/warehouse/purchase/delete',null,null,afterReq)">{{$t('shanchu')}}-->
            <!--            </el-button>-->
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>

    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body" :destroy-on-close="true">
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        {{
          $nextTick(() => {
            $refs.yt2.list = addList;
          })
        }}
        <div class="dialog-scroller" style="display: flex;flex-direction: column;">
          <div>
            <div style="margin-top: 8px;margin-bottom: 16px;color: #303133;font-weight: bold;font-size: 16px">
              {{ $t('caigoudingdantouxinxi') }}
            </div>
            <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth" style="margin-left: 100px">
              <!--<el-form-item :label="$t('caigoudingdanhao')" required>-->
              <!--<el-input v-model="yt.editObj.no"></el-input>-->
              <!--</el-form-item>-->
              <el-form-item :label="$t('gongyingshangmingcheng')" required>
                <yi_data_select type="supplier" :ids.sync="yt.editObj.supplierId" @change="getItemSupplier"></yi_data_select>
              </el-form-item>
              <el-form-item :label="$t('gongyingshangdizhi')" required>
                <el-input v-model="yt.editObj.supplierAddress" @input="$forceUpdate()"></el-input>
              </el-form-item>
              <el-form-item :label="$t('shouhuodizhi')" required>
                <el-input v-model="yt.editObj.address"></el-input>
              </el-form-item>
              <el-form-item :label="$t('shouhuofang')" required>
                <yi_data_select :max="1" :type="'organization'" :ids.sync="yt.editObj.orgId"></yi_data_select>
              </el-form-item>
              <el-form-item :label="$t('caigouyuan')" required>
                <!--                <el-input v-model="yt.editObj.remark"></el-input>-->
                <el-select v-model="yt.editObj.purchaser" clearable filterable>
                  <el-option v-for="(item, index) in userrList" :key="index" :label="item.nickname" :value="item.id"> </el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input v-model="yt.editObj.remark"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div style="margin-top: 8px;margin-bottom: 16px;color: #303133;font-weight: bold;font-size: 16px">
            {{ $t('caigoudingdanmingxixinxi') }}
          </div>
          <div style="flex:1;">
            <yi_curd_table :name="$options.name + '2'" ref="yt2" :columns="columnsItem">
              <!-- 左侧按钮插槽 -->
              <template #buttonsL="scope">
                <el-button size="mini" @click="addTable(scope._index, $event)" type="primary">
                  {{ $t('xinzeng') }}
                </el-button>
                <!--                <el-button size="mini" @click="isShowUploadDialog=true" plain>-->
                <!--                  {{$t('daoru')}}-->
                <!--                </el-button>-->
              </template>

              <template #caigoudingdanhanghao="scope">
                <el-input class="inputClass" v-model="scope.row.no" :disabled="true"></el-input>
              </template>
              <template #mingxizhuangtai="scope">
                <el-tag size="small" :value="scope.row.status">{{ $t('xinjian') }}</el-tag>
              </template>
              <template #wuliaobianmamingcheng="scope">
                <yi_cross_select :key="scope._index" class="inputClass" :max="1" :selectTitle="'code,name'" :component="'web_base_matter_list'" :ids.sync="scope.row.materialId" @getItems="getItems(scope._index, $event)"> </yi_cross_select>
              </template>
              <template #dingdanshuliang="scope">
                <el-input class="inputClass" v-model="scope.row.quantity"></el-input>
              </template>
              <template #caigoudanwei="scope">
                <el-input class="inputClass" v-model="scope.row.unit" disabled></el-input>
              </template>
              <template #dingdanjiaoqi="scope">
                <yi_time_input class="inputClass" :format="'yyyy-MM-dd'" type="date" :time.sync="scope.row.deliveryTime"> </yi_time_input>
              </template>
              <template #chaoliangjieshouyuncha="scope">
                <!--                <el-input class="inputClass" v-model="scope.row.tolerance"></el-input>-->
                <el-input-number disabled class="inputClass" :precision="2" :min="0" v-model="scope.row.tolerance" :controls="false"></el-input-number>
              </template>
              <template #sehao="scope">
                <yi_dictionary_select class="inputClass" type="CUSTOMER_MATERIAL_COLOR_NO" :ids.sync="scope.row.colorNo"></yi_dictionary_select>
              </template>
              <template #beizhu="scope">
                <el-input class="inputClass" v-model="scope.row.remark"></el-input>
              </template>
              <template #caozuo="scope">
                <el-row :gutter="10">
                  <el-col :span="0.1">
                    <el-button type="text" class="font-color-danger" @click="remove(scope._index, $event)">
                      {{ $t('shanchu') }}
                    </el-button>
                  </el-col>
                </el-row>
              </template>
            </yi_curd_table>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST', '/web/warehouse/purchase/create', beforeAdd, afterAddOrUpdate)" type="primary">
            {{ $t('baocun') }}
          </el-button>
          <!--          	<el-button :loading="yt.editObj.loading" size="mini"-->
          <!--                       @click="saveAdd" type="primary">-->
          <!--						{{$t('baocun')}}-->
          <!--					</el-button>-->
        </span>
      </template>
      <!-- 编辑 -->
      <template v-if="yt.editObj.action == 'bianji'">
        {{
          $nextTick(() => {
            $refs.yt2.list = editList;
          })
        }}
        <div class="dialog-scroller" style="display: flex;flex-direction: column;">
          <div>
            <div style="margin-top: 8px;margin-bottom: 16px;color: #303133;font-weight: bold;font-size: 16px">
              {{ $t('caigoudingdantouxinxi') }}
            </div>
            <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth" style="margin-left: 100px">
              <el-form-item :label="$t('caigoudingdanhao')" required>
                <el-input v-model="yt.editObj.no" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item :label="$t('gongyingshangmingcheng')" required>
                <yi_data_select type="supplier" :ids.sync="yt.editObj.supplierId" @change="getItemSupplier"></yi_data_select>
              </el-form-item>
              <el-form-item :label="$t('gongyingshangdizhi')" required>
                <el-input v-model="yt.editObj.supplierAddress" @input="$forceUpdate()"></el-input>
              </el-form-item>
              <el-form-item :label="$t('shouhuodizhi')" required>
                <el-input v-model="yt.editObj.address"></el-input>
              </el-form-item>
              <el-form-item :label="$t('shouhuofang')" required>
                <yi_data_select :max="1" :type="'organization'" :ids.sync="yt.editObj.orgId"></yi_data_select>
              </el-form-item>
              <el-form-item :label="$t('caigouyuan')" required>
                <!--                <el-input v-model="yt.editObj.remark"></el-input>-->
                <el-select v-model="yt.editObj.purchaser" clearable filterable>
                  <el-option v-for="(item, index) in userrList" :key="index" :label="item.nickname" :value="item.id"> </el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input v-model="yt.editObj.remark"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div style="margin-top: 8px;margin-bottom: 16px;color: #303133;font-weight: bold;font-size: 16px">
            {{ $t('caigoudingdanmingxixinxi') }}
          </div>
          <div style="flex:1;">
            <yi_curd_table v-bind="$attrs" :name="$options.name + '2'" ref="yt2" :columns="columnsItem">
              <template #buttonsL="scope">
                <el-button size="mini" @click="addEditTable(scope._index, $event)" type="primary">
                  {{ $t('xinzeng') }}
                </el-button>
                <!--                <el-button size="mini" @click="isShowUploadDialog=true" plain>-->
                <!--                  {{$t('daoru')}}-->
                <!--                </el-button>-->
              </template>
              <template #caigoudingdanhanghao="scope">
                <el-input class="inputClass" v-model="scope.row.no" :disabled="true"></el-input>
              </template>
              <template #mingxizhuangtai="scope">
                <span v-if="scope.row.status === '0'">
                  <el-tag size="small" :value="scope.row.status">{{ $t('xinjian') }}</el-tag>
                </span>
                <span v-if="scope.row.status === '1'">
                  <el-tag size="small" :value="scope.row.status" style="color: #597EF7;background-color: #F0F5FF">{{ $t('yifabu') }}</el-tag>
                </span>
              </template>
              <template #wuliaobianmamingcheng="scope">
                <yi_cross_select :key="scope._index" class="inputClass" :max="1" :selectTitle="'code,name'" :component="'web_base_matter_list'" :ids.sync="scope.row.materialId" @getItems="getItems(scope._index, $event)"> </yi_cross_select>
              </template>
              <template #dingdanshuliang="scope">
                <el-input class="inputClass" v-model="scope.row.quantity"></el-input>
              </template>
              <template #caigoudanwei="scope">
                <el-input class="inputClass" v-model="scope.row.unit" disabled></el-input>
              </template>
              <template #dingdanjiaoqi="scope">
                <yi_time_input class="inputClass" :format="'yyyy-MM-dd'" type="date" :time.sync="scope.row.deliveryTime"> </yi_time_input>
              </template>
              <template #chaoliangjieshouyuncha="scope">
                <!--                <el-input class="inputClass" v-model="scope.row.tolerance"></el-input>-->
                <el-input-number class="inputClass" disabled :precision="2" :min="0" v-model="scope.row.tolerance" :controls="false"></el-input-number>
              </template>
              <template #sehao="scope">
                <yi_dictionary_select class="inputClass" type="CUSTOMER_MATERIAL_COLOR_NO" :ids.sync="scope.row.colorNo"></yi_dictionary_select>
              </template>
              <template #beizhu="scope">
                <el-input class="inputClass" v-model="scope.row.remark"></el-input>
              </template>
              <template #caozuo="scope">
                <el-row :gutter="10">
                  <el-col :span="0.1">
                    <el-button type="text" class="font-color-danger" @click="removeEdit(scope._index, $event)">
                      {{ $t('shanchu') }}
                    </el-button>
                  </el-col>
                </el-row>
              </template>
            </yi_curd_table>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" :loading="yt.editObj.loading" @click="yt.req('POST', '/web/warehouse/purchase/updateWithDetail', beforeEditAdd, afterEditOrUpdate)" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!--查看-->
      <template v-if="yt.editObj.action == 'chakan'">
        {{
          $nextTick(() => {
            $refs.yt2.list = editList;
          })
        }}
        <div class="dialog-scroller" style="display: flex;flex-direction: column;">
          <div>
            <div style="margin-top: 8px;margin-bottom: 16px;color: #303133;font-weight: bold;font-size: 16px">
              {{ $t('caigoudingdantouxinxi') }}
            </div>
            <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth" style="margin-left: 100px">
              <el-form-item :label="$t('caigoudingdanhao')" required class="noborder">
                <el-input v-model="yt.editObj.no" disabled></el-input>
              </el-form-item>
              <el-form-item :label="$t('gongyingshangmingcheng')" required class="noborder">
                <yi_data_select type="supplier" :ids.sync="yt.editObj.supplierId" @change="getItemSupplier" disabled></yi_data_select>
              </el-form-item>
              <el-form-item :label="$t('gongyingshangdizhi')" required class="noborder">
                <el-input v-model="yt.editObj.supplierAddress" disabled></el-input>
              </el-form-item>
              <el-form-item :label="$t('shouhuodizhi')" required class="noborder">
                <el-input v-model="yt.editObj.address" disabled></el-input>
              </el-form-item>
              <el-form-item :label="$t('shouhuofang')" required class="noborder">
                <yi_data_select :max="1" :type="'organization'" :ids.sync="yt.editObj.orgId" disabled></yi_data_select>
              </el-form-item>
              <el-form-item :label="$t('caigouyuan')" required class="noborder">
                <el-select v-model="yt.editObj.purchaser" clearable filterable disabled>
                  <el-option v-for="(item, index) in userrList" :key="index" :label="item.nickname" :value="item.id"> </el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')" class="noborder">
                <el-input v-model="yt.editObj.remark" disabled></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div style="margin-top: 8px;margin-bottom: 16px;color: #303133;font-weight: bold;font-size: 16px">
            {{ $t('caigoudingdanmingxixinxi') }}
          </div>
          <div style="flex:1;">
            <yi_curd_table v-bind="$attrs" :name="$options.name + '2'" ref="yt2" :columns="checkItem">
              <template #buttonsL="scope">
                <!--                <el-button size="mini" @click="isShowUploadDialog=true" plain>-->
                <!--                  {{$t('daoru')}}-->
                <!--                </el-button>-->
              </template>
              <template #caigoudingdanhanghao="scope">
                <el-input class="inputClass" v-model="scope.row.no" disabled></el-input>
              </template>
              <template #mingxizhuangtai="scope">
                <span v-if="scope.row.status === '0'">
                  <el-tag size="small" :value="scope.row.status">{{ $t('xinjian') }}</el-tag>
                </span>
                <span v-if="scope.row.status === '1'">
                  <el-tag size="small" :value="scope.row.status" style="color: #597EF7;background-color: #F0F5FF">{{ $t('yifabu') }}</el-tag>
                </span>
                <span v-if="scope.row.status === '2'">
                  <el-tag size="small" :value="scope.row.status" style="color: #67C23A;background-color: #F0F9EB">{{ $t('yijieshou') }}</el-tag>
                </span>
                <span v-if="scope.row.status === '3'">
                  <el-tag size="small" :value="scope.row.status" style="color: #F56C6C;background-color: #FEF0F0">{{ $t('yijushou') }}</el-tag>
                </span>
                <span v-if="scope.row.status === '4'">
                  <el-tag size="small" :value="scope.row.status" style="color: #909399;background-color: #F4F4F5">{{ $t('yiquxiao') }}</el-tag>
                </span>
                <span v-if="scope.row.status === '5'">
                  <el-tag size="small" :value="scope.row.status" style="color: #E6A23C;background-color: #FDF6EB">{{ $t('songhuozhong') }}</el-tag>
                </span>
                <span v-if="scope.row.status === '6'">
                  <el-tag size="small" :value="scope.row.status" style="color: #909399;background-color: #F4F4F5">{{ $t('yiguanbi') }}</el-tag>
                </span>
                <span v-if="scope.row.status === '7'">
                  <el-tag size="small" :value="scope.row.status" style="color: #909399;background-color: #F4F4F5">{{ $t('yishouhuo') }}</el-tag>
                </span>
              </template>
              <template #wuliaobianmamingcheng="scope">
                <yi_cross_select disabled :key="scope._index" class="inputClass" :max="1" :selectTitle="'code,name'" :component="'web_base_matter_list'" :ids.sync="scope.row.materialId" @getItems="getItems(scope._index, $event)"> </yi_cross_select>
              </template>
              <template #dingdanshuliang="scope">
                <el-input class="inputClass" v-model="scope.row.quantity" disabled></el-input>
              </template>
              <template #caigoudanwei="scope">
                <el-input class="inputClass" v-model="scope.row.unit" disabled></el-input>
              </template>
              <template #dingdanjiaoqi="scope">
                <yi_time_input class="inputClass" :format="'yyyy-MM-dd'" type="date" :time.sync="scope.row.deliveryTime" disabled> </yi_time_input>
              </template>
              <template #chaoliangjieshouyuncha="scope">
                <el-input-number class="inputClass" disabled :precision="2" :min="0" v-model="scope.row.tolerance" :controls="false"></el-input-number>
              </template>
              <template #beizhu="scope">
                <el-input class="inputClass" v-model="scope.row.remark" disabled></el-input>
              </template>
              <!--              <template #jieshoushuliang="scope">-->

              <!--              </template>-->
              <!--              <template #leijituihuoshuliang="scope">-->

              <!--              </template>-->
              <!--              <template #leijiqiansongshuliang="scope">-->

              <!--              </template>-->
              <!--              <template #jushouyuanyin="scope">-->

              <!--              </template>-->
              <!--              <template #quxiaoyuanyin="scope">-->

              <!--              </template>-->
            </yi_curd_table>
          </div>
        </div>
      </template>
    </el-dialog>
    <!--    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="isShowUploadDialog"-->
    <!--               width="80%" :close-on-click-modal="false" append-to-body="append-to-body">-->
    <!--      <div class="dialog-scroller">-->
    <!--        <import_excel v-if="isShowUploadDialog" ref="importExcel"/>-->
    <!--      </div>-->
    <!--      <span slot="footer" class="dialog-footer">-->
    <!--				<el-button type="default" size="mini" @click="isShowUploadDialog = false">{{$t('quxiao')}}</el-button>-->
    <!--				<el-button type="primary" size="mini" @click="save()">{{$t('baocun')}}</el-button>-->
    <!--			</span>-->
    <!--    </el-dialog>-->
    <import-excel :show.sync="importShow" />
  </div>
</template>
<script type="text/javascript">
import Yi_dictionary_select from '@/common/yi_dictionary_select/yi_dictionary_select.vue';
import importExcel from './import_excel';
export default {
  name: 'web_purchasing_management_purchase_order_list',
  components: {
    importExcel
  },
  data() {
    return {
      addList: [],
      editList: [],
      newList: [],
      rejectStatus: '',
      isShowUploadDialog: false,
      supplierList: [],
      userrList: [],
      importShow: false,
      colorNoEnable: false,
      columnsItem: [
        {
          label: 'caigoudingdanhanghao',
          prop: 'no',
          type: 'slot',
          wrap: true,
          width: 130
        },
        {
          label: 'mingxizhuangtai',
          prop: 'status',
          type: 'slot',
          wrap: true,
          width: 80
        },
        {
          label: 'wuliaobianmamingcheng',
          prop: 'materialId',
          type: 'slot',
          wrap: true,
          width: 130
        },
        {
          label: 'dingdanshuliang',
          prop: 'quantity',
          type: 'slot',
          wrap: true,
          width: 130
        },
        {
          label: 'caigoudanwei',
          prop: 'defaultUnit',
          type: 'slot',
          wrap: true
          // width: 130
        },
        {
          label: 'caigoushenqinghao',
          prop: 'purchaseRequisitionNo',
          wrap: true
          // width: 130
        },
        {
          label: 'dingdanjiaoqi',
          prop: 'deliveryTime',
          width: 150,
          type: 'slot',
          wrap: true
          // width: 130
        },
        {
          label: 'chaoliangjieshouyuncha',
          prop: 'tolerance',
          type: 'slot',
          wrap: true,
          width: 160
        },
        {
          label: 'sehao',
          prop: 'colorNo',
          type: 'slot',
          wrap: true,
          width: 160,
          show: false
        },
        {
          label: 'beizhu',
          prop: 'remark',
          type: 'slot',
          wrap: true
          // width: 130
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 100,
          wrap: true,
          fixed: 'right'
        }
      ],
      //列
      columns: [
        {
          label: 'caigoudingdanhao',
          prop: 'no',
          width: 130
        },
        {
          label: 'gongyingshangmingcheng',
          prop: 'supplier.name',
          width: 130
        },
        {
          label: 'gongyingshangdizhi',
          prop: 'supplierAddress',
          width: 130
        },
        {
          label: 'shouhuodizhi',
          prop: 'address',
          width: 130
        },
        {
          label: 'shouhuofang',
          prop: 'org.name',
          width: 130
        },
        {
          label: 'caigouyuan',
          prop: 'purchaserObject.nickname',
          width: 130
        },
        {
          label: 'laiyuan',
          prop: 'source',
          type: 'dictionary',
          key: 'DATA_SOURCE',
          width: 150
        },
        {
          label: 'beizhu',
          prop: 'remark',
          width: 130
        },

        {
          label: 'shenhezhuangtai',
          prop: 'status',
          type: 'tag',
          tags: {
            0: {
              color: '#F56C6C',
              text: this.$t('daishenhe')
            },
            1: {
              color: '#9254DE',
              text: this.$t('yishenhe')
            }
          }
        },
        {
          label: 'danjuzhuangtai',
          prop: 'documentStatus',
          type: 'tag',
          tags: {
            1: {
              color: '#419FFF',
              text: this.$t('xinjian')
            },
            2: {
              color: '#597EF7',
              text: this.$t('yifabu')
            },
            3: {
              color: '#F56C6C',
              text: this.$t('yijushou')
            },
            4: {
              color: '#909399',
              text: this.$t('yiquxiao')
            },
            5: {
              color: '#67C23A',
              text: this.$t('shouhuozhong')
            },
            6: {
              color: '#E6A23C',
              text: this.$t('yiguanbi')
            },
            7: {
              color: '#909399',
              text: this.$t('yishouhuo')
            }
          }
        },
        {
          label: 'chuangjianren',
          prop: 'createByObject.nickname',
          width: 130
        },
        {
          label: 'chuangjianshijian',
          prop: 'createTime',
          type: 'time',
          format: 'YYYY-MM-DD HH:mm:ss',
          width: 180
        },
        {
          label: 'shenheren',
          prop: 'reviewedByObject.nickname',
          width: 130
        },
        {
          label: 'shenheshijian',
          prop: 'reviewedTime',
          type: 'time',
          format: 'YYYY-MM-DD HH:mm:ss',
          width: 180
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 230,
          fixed: 'right'
        }
      ],
      //查看列
      checkItem: [
        {
          label: 'caigoudingdanhanghao',
          prop: 'no',
          type: 'slot',
          wrap: true,
          width: 130
        },
        {
          label: 'mingxizhuangtai',
          prop: 'status',
          type: 'slot',
          wrap: true,
          width: 80
        },
        {
          label: 'wuliaobianmamingcheng',
          prop: 'materialId',
          type: 'slot',
          wrap: true,
          width: 130
        },
        {
          label: 'dingdanshuliang',
          prop: 'quantity',
          type: 'slot',
          wrap: true,
          width: 130
        },
        {
          label: 'caigoudanwei',
          prop: 'defaultUnit',
          type: 'slot',
          wrap: true
          // width: 130
        },
        {
          label: 'caigoushenqinghao',
          prop: 'purchaseRequisitionNo',
          wrap: true,
          width: 130
        },
        {
          label: 'dingdanjiaoqi',
          prop: 'deliveryTime',
          width: 150,
          type: 'slot',
          wrap: true
          // width: 130
        },
        {
          label: 'chaoliangjieshouyuncha',
          prop: 'tolerance',
          type: 'slot',
          wrap: true,
          width: 150
        },
        {
          label: 'sehao',
          prop: 'colorNo',
          type: 'dictionary',
          key: 'CUSTOMER_MATERIAL_COLOR_NO',
          width: 150,
          show: false
        },
        {
          label: 'beizhu',
          prop: 'remark',
          type: 'slot',
          wrap: true
          // width: 130
        },
        {
          label: 'jieshoushuliang',
          prop: 'receivedQuantity',
          // type: 'slot',
          wrap: true,
          width: 130
        },
        {
          label: 'leijituihuoshuliang',
          prop: 'refusalQuantity',
          // type: 'slot',
          wrap: true,
          width: 130
        },
        {
          label: 'leijiqiansongshuliang',
          prop: 'unreceivedQuantity',
          // type: 'slot',
          wrap: true,
          width: 130
        },
        {
          label: 'jushouyuanyin',
          prop: 'refuseCause',
          // type: 'slot',
          wrap: true,
          width: 130
        },
        {
          label: 'quxiaoyuanyin',
          prop: 'cancelCause',
          // type: 'slot',
          wrap: true,
          width: 130
        }
      ]
    };
  },
  watch: {
    'yt.isShowEditDialog': {
      handler(n) {
        if (this.yt.editObj.action == 'xinzeng' && n == false) {
          this.addList = [];
        }
      },
      immediate: false,
      deep: true
    }
  },
  created() {
    this.getProductionConfig();
    setTimeout(() => {
      this.yt.get(1, null, this.afterReq);
    }, 300);
  },
  methods: {
    // 查询生产配置-启用产品色号管理
    getProductionConfig() {
      this.http.get('/web/production/config/list?type=26&status=1').then(res => {
        if (res.code === 200 && res.data && res.data.length > 0) {
          this.colorNoEnable = true;
        }
        if (this.colorNoEnable) {
          this.showColumnsItem('sehao');
          this.showCheckItem('sehao');
        }
      });
    },
    // 显示 新增/编辑-销售订单明细 指定列
    showColumnsItem(label) {
      for (let i = 0; i < this.columnsItem.length; i++) {
        const c = this.columnsItem[i];
        if (c.label === label) {
          c.show = true;
          break;
        }
      }
    },
    // 显示 查看-销售订单明细 指定列
    showCheckItem(label) {
      for (let i = 0; i < this.checkItem.length; i++) {
        const c = this.checkItem[i];
        if (c.label === label) {
          c.show = true;
          break;
        }
      }
    },
    beforeEditAdd(params, url) {
      params.purchaseOrderDetailList = this.editList;
      return params;
    },
    afterEditOrUpdate() {
      this.yt.isShowEditDialog = false;
      this.yt.get(1, null, this.afterReq);
    },
    removeEdit(index, item) {
      this.editList.splice(index, 1);

      for (let i = index; i < this.editList.length; i++) {
        this.editList[i].no = this.editList[i].no - 1;
      }
    },
    beforeEdit(row) {
      this.editList = row.purchaseOrderDetailList;
      return row;
    },
    addEditTable(row) {
      let no = null;
      if (this.editList) {
        no = this.editList.length + 1;
      } else {
        no = 1;
      }
      const newItem = {
        no: no,
        status: '0',
        materialId: '',
        quantity: '',
        unit: '',
        deliveryTime: '',
        tolerance: '',
        remark: ''
      };
      this.editList.push(newItem);
    },
    afterAddOrUpdate() {
      this.yt.isShowEditDialog = false;
      this.yt.get(1, null, this.afterReq);
    },
    removeRecord(row) {
      this.$confirm(this.$t('shanchujiangbukehuifu,shifoujixu?'), this.$t('jinggao'), {
        confirmButtonText: this.$t('queding'),
        cancelButtonText: this.$t('quxiao'),
        type: 'warning',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            done();
            setTimeout(() => {
              instance.confirmButtonLoading = false;
              done();
            }, 2000);
          } else {
            done();
          }
        }
      })
        .then(() => {
          return this.http
            .post('/web/warehouse/purchase/delete', {
              id: row.id
            })
            .then(res => {
              this.$message.success(this.$t(res.msg));
              this.yt.get(1, null, this.afterReq);
            })
            .catch(error => {
              this.$message.error(this.$t(error));
            });
        })
        .catch(() => {});
    },
    //审核驳回
    reject(row) {
      this.http
        .post('/web/warehouse/purchase/review', {
          id: row.id,
          status: 0
        })
        .then(res => {
          this.utils.successMessage(this.$t(res.msg));
          this.yt.get(1, null, this.afterReq);
        })
        .catch(error => {
          this.utils.errorMessage(this.$t(error));
        });
    },
    //审核
    process(row) {
      this.http
        .post('/web/warehouse/purchase/review', {
          id: row.id,
          status: 1
        })
        .then(res => {
          this.utils.successMessage(this.$t(res.msg));
          this.yt.get(1, null, this.afterReq);
        })
        .catch(error => {
          this.utils.errorMessage(this.$t(error));
        })
        .finally(() => {
          this.$set(row, 'processLoading', false);
        });
    },
    afterGet() {
      setTimeout(() => {
        for (let i = 0; i < this.yt.list.length; i++) {
          const rowList = this.yt.list[i]['purchaseOrderDetailList'];
          this.$set(this.yt.list[i], 'documentStatus', 1);
          if (this.yt.list[i].status === '0') {
            this.$set(this.yt.list[i], 'documentStatus', 1);
          }
          if (this.yt.list[i].status === '1') {
            this.$set(this.yt.list[i], 'documentStatus', 2);
          }
          if (rowList.every(item => item.status === '3')) {
            this.$set(this.yt.list[i], 'documentStatus', 3);
          }
          if (rowList.every(item => item.status === '4')) {
            this.$set(this.yt.list[i], 'documentStatus', 4);
          }
          rowList.forEach(r => {
            if (r.status === '5') {
              this.$set(this.yt.list[i], 'documentStatus', 5);
            }
          });
          if (rowList.every(item => item.status === '7')) {
            this.$set(this.yt.list[i], 'documentStatus', 7);
          }
          if (this.yt.list[i].documentStatus != '3' && this.yt.list[i].documentStatus != '4') {
            if (rowList.every(item => item.status === '3' || item.status === '7')) {
              this.$set(this.yt.list[i], 'documentStatus', 7);
            }
            if (rowList.every(item => item.status === '4' || item.status === '7')) {
              this.$set(this.yt.list[i], 'documentStatus', 7);
            }
            // 定义包含的状态值
            const validStatus = ['3', '4', '7'];
            // 计算 rowList 中包含的有效状态值的数量
            const validStatusCount = rowList.filter(item => validStatus.includes(item.status)).length;
            // 如果有效状态值的数量大于等于 3，则设置 documentStatus 为 7
            if (validStatusCount >= 3) {
              this.$set(this.yt.list[i], 'documentStatus', 7);
            }
            if (rowList.every(item => item.status === '3' || item.status === '4' || item.status === '6')) {
              this.$set(this.yt.list[i], 'documentStatus', 6);
            }
          }
          //审核驳回:【单据状态】以及采购订单下【明细状态】都为【1】才显示
          if (this.yt.list[i]['status'] === '1' && rowList.every(item => item.status === '1')) {
            this.$set(this.yt.list[i], 'rejectStatus', 0);
            console.log('b都为1', 11111111111);
          } else {
            this.$set(this.yt.list[i], 'rejectStatus', 1);
          }
        }
      }, 10);
    },
    afterReq(result) {
      if (result.data.rows.length > 0) {
        for (let i = 0; i < result.data.rows.length; i++) {
          const rowList = result.data.rows[i]['purchaseOrderDetailList'];
          this.$set(result.data.rows[i], 'documentStatus', 1);
          if (result.data.rows[i].status === '0') {
            this.$set(result.data.rows[i], 'documentStatus', 1);
          }
          if (result.data.rows[i].status === '1') {
            this.$set(result.data.rows[i], 'documentStatus', 2);
          }
          if (rowList.every(item => item.status === '3')) {
            this.$set(result.data.rows[i], 'documentStatus', 3);
          }
          if (rowList.every(item => item.status === '4')) {
            this.$set(result.data.rows[i], 'documentStatus', 4);
          }
          rowList.forEach(r => {
            if (r.status === '5') {
              this.$set(result.data.rows[i], 'documentStatus', 5);
            }
          });
          if (rowList.every(item => item.status === '7')) {
            this.$set(result.data.rows[i], 'documentStatus', 7);
          }
          console.log('result.data.rows[i].documentStatus' + result.data.rows[i].documentStatus, result.data.rows[i].documentStatus != '3');
          if (result.data.rows[i].documentStatus != '3' && result.data.rows[i].documentStatus != '4') {
            if (rowList.every(item => item.status === '3' || item.status === '7')) {
              this.$set(result.data.rows[i], 'documentStatus', 7);
            }
            if (rowList.every(item => item.status === '4' || item.status === '7')) {
              this.$set(result.data.rows[i], 'documentStatus', 7);
            }
            // 定义包含的状态值
            const validStatus = ['3', '4', '7'];
            // 计算 rowList 中包含的有效状态值的数量
            const validStatusCount = rowList.filter(item => validStatus.includes(item.status)).length;
            // 如果有效状态值的数量大于等于 3，则设置 documentStatus 为 7
            if (validStatusCount >= 3) {
              this.$set(result.data.rows[i], 'documentStatus', 7);
            }
            if (rowList.every(item => item.status === '3' || item.status === '4' || item.status === '6')) {
              this.$set(result.data.rows[i], 'documentStatus', 6);
            }
          }
          //审核驳回:【单据状态】以及采购订单下【明细状态】都为【1】才显示
          if (result.data.rows[i]['status'] === '1' && rowList.every(item => item.status === '1')) {
            this.$set(result.data.rows[i], 'rejectStatus', 0);
            console.log('b都为1', 11111111111);
          } else {
            this.$set(result.data.rows[i], 'rejectStatus', 1);
          }
        }
      }
      return result;
    },
    setDefaultValue() {
      if (this.store.state.organizations.length > 0) {
        this.yt.editObj.orgId = this.store.state.organizations[0].id;
      }
      if (this.store.state.user.id) {
        this.yt.editObj.purchaser = this.store.state.user.id;
      }
    },
    beforeAdd(params, url) {
      params.status = '0';
      params.purchaseOrderDetailList = this.$refs.yt2.list;
      return params;
    },
    getItemSupplier(id, item) {
      this.yt.editObj.supplierAddress = item.address;
    },
    getItems(index, item) {
      this.$set(this.$refs.yt2.list[index], 'unit', item.defaultUnitLabel || '');
      this.$set(this.$refs.yt2.list[index], 'tolerance', item.otherInfo.exceedAcceptDiff || '');
    },
    remove(index, item) {
      this.addList.splice(index, 1);
      for (let i = index; i < this.addList.length; i++) {
        this.addList[i].no = this.addList[i].no - 1;
      }
    },
    addTable(rows) {
      let no = null;
      if (this.addList) {
        no = this.addList.length + 1;
      } else {
        no = 1;
      }
      const newItem = {
        no: no,
        status: '0',
        materialId: '',
        quantity: '',
        defaultUnit: '',
        deliveryTime: '',
        tolerance: '',
        remark: ''
      };
      this.addList.push(newItem);
    },
    // 获取供应商编码、名称
    async getSupplierList() {
      return await this.http
        .get(
          '/web/supplier/page?' +
            this.qs.stringify({
              pageNum: 1,
              pageSize: 999
              // orderBy: 'sort',
            })
        )
        .then(response => {
          this.supplierList = response.data.rows || [];
          for (let i = 0; i < this.supplierList.length; i++) {
            const supplierCodeName = this.supplierList[i]['code'] + '/' + this.supplierList[i]['name'];
            this.$set(this.supplierList[i], 'supplierCodeName', supplierCodeName);
          }
          console.log('this.supplierList', this.supplierList);
        });
    },
    async getCustomer() {
      return await this.http
        .get(
          '/web/customer/auth/user/page?' +
            this.qs.stringify({
              pageNum: 1,
              pageSize: 999,
              enabled: true
            })
        )
        .then(response => {
          this.userrList = response.data.rows || [];
        });
    },
    //增加一条出库信息
    addItem() {
      console.log('this.yt.editObj.inOrderDetailList', this.yt.editObj.inOrderDetailList);
      this.yt.editObj.inOrderDetailList.push({
        materialId: null,
        materialBatchNo: '',
        unit: '',
        quantity: undefined,
        remark: ''
      });
    },
    /**
     * 物料选中后回调
     * @param index 当前行
     * @param item 选中后的项目
     */
    changeMaterial(index, item) {
      this.$set(this.yt.editObj.inOrderDetailList[index], 'unit', item.defaultUnit || '');
    },
    changeMaterialUpdate(index, item) {
      this.$set(this.yt.editObj.inOrderDetailList[index], 'unit', item.defaultUnit || '');
    }
    // save() {
    //   let importData = this.$refs.importExcel.convertData
    //   this.isShowUploadDialog = false
    //   if (importData && importData.length > 0) {
    //     if (this.yt.editObj.action === 'xinzeng') {
    //       this.yt.editObj.inOrderDetailList = []
    //       this.$nextTick(() => {
    //         importData.forEach((item) => {
    //           item.materialId = Number(item.materialId)
    //         })
    //         this.yt.editObj.inOrderDetailList = importData
    //       })
    //     } else if (this.yt.editObj.action === 'bianji') {
    //       this.$nextTick(() => {
    //         importData.forEach((item) => {
    //           item.materialId = Number(item.materialId)
    //           this.yt.editObj.inOrderDetailList.push(item)
    //         })
    //       })
    //     }
    //   }
    // }
  }
};
</script>
